// extracted by mini-css-extract-plugin
module.exports = {"tagBubble":"TagBubble_tagBubble__v9hVv"};